import { CustomTable, Modal, Combobox, CustomTableRef, EInputTypes, ErrorModal, InputTextCustom } from "medere-ui-framework"
import { RefObject, useEffect, useRef, useState } from "react"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { MultiSelect } from "primereact/multiselect"
import { findAAById, findAccountingById, getAllAccountingAccountsByLevel, getAllAccountings } from "../../servicesHooks/Accounting/useAccountingService"
import { Accounting, TaxType } from "../../interface/interface"
import { useIntl } from "react-intl"
import { useSearchParams } from 'react-router';
import { useTaxService } from "../../servicesHooks/Tax/useTaxService"
type FormsList = {
    id: number,
    label: string,
    variable: string,
}

const formsList = [
    {
        id: 1,
        label: "Compras",
        variable: "forPurchaseInvoices"
    }, {
        id: 2,
        label: "Ventas",
        variable: "forSalesInvoices",
    }, {
        id: 3,
        label: "Pago a terceros",
        variable: "forPaymentsToOthers",
    }, {
        id: 4,
        label: "Pago de terceros",
        variable: "forPaymentsFromOthers",
    }
]

type TaxModalProps = {
    visible: boolean
    setVisible: (a: boolean) => void
    tableRef: RefObject<CustomTableRef>
    selectedTax?: TaxType

}

function TaxModal({ visible, setVisible, tableRef, selectedTax}: TaxModalProps) {
    const { editTax, saveTax } = useTaxService();

    const [taxName, setTaxName] = useState<string>('')
    const [taxValue, setTaxValue] = useState<number>(0)
    const [vatTax, setVatTax] = useState(false)
    const [isEarningsWithHolding, setEarningsWithHolding] = useState(false)
    const [isIibbWithHolding, setIibbWithHolding] = useState(false)
    const [exemptVatTax, setExemptVatTax] = useState(false)
    const [vatNotTaxed, setVatNotTaxed] = useState(false)
    const [accounting, setAccounting] = useState<Accounting>()
    const [accountingAccount, setAccountingAccount] = useState()
    const [selectedForms, setSelectedForms] = useState<FormsList[]>([])

    const [nameError, setNameError] = useState(false)
    const [valueError, setValueError] = useState(false)

    useEffect(() => {
        if (selectedTax) {
            setTaxName(selectedTax.taxname)
            setTaxValue(selectedTax.taxvalue)
            setVatTax(selectedTax.vattax)
            setEarningsWithHolding(selectedTax.isearningswithholding)
            setIibbWithHolding(selectedTax.isiibbwithholding)
            setVatNotTaxed(selectedTax?.vatnottaxed)
            setExemptVatTax(selectedTax.exemptvattax)
            let _selectedForms = []
            if (selectedTax.forpurchaseinvoices) {
                _selectedForms.push({
                    id: 1,
                    label: "Compras",
                    variable: "forPurchaseInvoices"
                })
            }
            if (selectedTax.forsalesinvoices) {
                _selectedForms.push({
                    id: 2,
                    label: "Ventas",
                    variable: "forSalesInvoices",
                })
            }
            if (selectedTax.forpaymentstoothers) {
                _selectedForms.push({
                    id: 3,
                    label: "Pago a terceros",
                    variable: "forPaymentsToOthers",
                })
            }
            if (selectedTax.forpaymentsfromothers) {
                _selectedForms.push({
                    id: 4,
                    label: "Pago de terceros",
                    variable: "forPaymentsFromOthers",
                })
            }
            setSelectedForms(_selectedForms)
            if (selectedTax.accounting && selectedTax.taxaccount) {
                findAccountingById({ accountingId: selectedTax.accounting })
                    .then(res => setAccounting(res))
                    .then(() => {
                        findAAById({accountingAccountId: selectedTax.taxaccount }).then(res => setAccountingAccount(res))
                    })
            }
        }
    }, [selectedTax])

    function cleanVariables() {
        setTaxName('')
        setTaxValue(0)
        setVatTax(false)
        setEarningsWithHolding(false)
        setIibbWithHolding(false)
        setAccounting(undefined)
        setAccountingAccount(undefined)
        setSelectedForms([])
    }

    function validations() {
        if (taxName === '') {
            setNameError(true)
            return false
        }
        if (taxValue == null) {
            setValueError(true)
            return false
        }
        return true
    }

    function searchInSelectedForm(variable: string) {
        return selectedForms.some(form => form.variable === variable)
    }

    function addTax() {
        if (!validations()) {
            return
        }
        let forPurchaseInvoices = searchInSelectedForm('forPurchaseInvoices')
        let forSalesInvoices = searchInSelectedForm('forSalesInvoices')
        let forPaymentsToOthers = searchInSelectedForm('forPaymentsToOthers')
        let forPaymentsFromOthers = searchInSelectedForm('forPaymentsFromOthers')
        if (taxValue != null) {
            saveTax({ taxName, taxValue, vatTax, isEarningsWithHolding, isIibbWithHolding, forPurchaseInvoices, forSalesInvoices, forPaymentsToOthers, forPaymentsFromOthers, accountingAccount, exemptVatTax, vatNotTaxed }).then(() => {
                setVisible(false)
                if (tableRef.current?.refreshTable) {
                    tableRef.current.refreshTable()
                }
                cleanVariables()
            })
        }

    }

    function updateTax() {
        if (!validations()) {
            return
        }
        let forPurchaseInvoices = searchInSelectedForm('forPurchaseInvoices')
        let forSalesInvoices = searchInSelectedForm('forSalesInvoices')
        let forPaymentsToOthers = searchInSelectedForm('forPaymentsToOthers')
        let forPaymentsFromOthers = searchInSelectedForm('forPaymentsFromOthers')
        if (taxValue != null)
            editTax({ taxType: selectedTax?.taxtype, taxName, taxValue, vatTax, isEarningsWithHolding, isIibbWithHolding, forPaymentsFromOthers, forPaymentsToOthers, forPurchaseInvoices, forSalesInvoices, accountingAccount, exemptVatTax, vatNotTaxed }).then(() => {
                setVisible(false)
                if (tableRef.current?.refreshTable) {
                    tableRef.current.refreshTable()
                }
                cleanVariables()
            })
    }


    return (
        <>
            <Modal
                visible={visible}
                setVisible={setVisible}
                footerButtonRightText="Agregar"
                onClickRightBtn={selectedTax ? updateTax : addTax}
            >
                <InputTextCustom
                    label="Nombre"
                    error={nameError}
                    required
                    caption={nameError ? "Este campo es obligatorio y debe estar lleno para continuar." : ""}
                    inputType={EInputTypes.TEXT}
                    value={taxName}
                    onChange={(e) => {
                        setTaxName(e.target.value)
                        setNameError(false)
                    }}
                />
                <InputTextCustom
                    label="%"
                    error={valueError}
                    required
                    caption={valueError ? "Este campo es obligatorio y debe estar lleno para continuar." : ""}
                    minFractionDigits={1}
                    inputType={EInputTypes.NUMBER}
                    value={taxValue}
                    onChange={(e) => {
                        setTaxValue(e.target.value)
                        setValueError(false)
                    }}
                />
                <div className="flex flex-row gap-4">
                    <Combobox
                        getItems={getAllAccountings}
                        label="Plan de cuentas"
                        optionLabel="description"
                        value={accounting}
                        setValue={setAccounting}
                    />
                    <Combobox
                        getItems={getAllAccountingAccountsByLevel}
                        params={{
                            accounting: accounting?.accounting,
                            level: accounting?.treesize,
                        }}
                        reLoadItemsValue={accounting}
                        label="Cuenta contable designada"
                        placeholder="Ejemplo: xxxxx (X.X.X)"
                        optionLabel="fulldescription"
                        value={accountingAccount}
                        setValue={setAccountingAccount} />
                </div>

                <label htmlFor="formsList" className="">Se utiliza en</label>
                <MultiSelect
                    inputId="formsList"
                    options={formsList}
                    optionLabel="label"
                    placeholder=""
                    value={selectedForms}
                    onChange={(e) => setSelectedForms(e.value)}
                    className="w-full" />
                <div className="gap-3" style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="mt-2">
                        <Checkbox
                            inputId="vatTax"
                            checked={vatTax}
                            onChange={(e: any) => setVatTax(e.checked)} />
                        <label htmlFor="vatTax" className="ml-2">Es IVA</label>
                    </div>
                    <div className="mt-2">
                        <Checkbox
                            inputId="exemptVatTax"
                            checked={exemptVatTax}
                            onChange={(e: any) => setExemptVatTax(e.checked)} />
                        <label htmlFor="exemptVatTax" className="ml-2">Es IVA exento</label>
                    </div>
                    <div className="mt-2">
                        <Checkbox
                            inputId="vatNotTaxed"
                            checked={vatNotTaxed}
                            onChange={(e: any) => setVatNotTaxed(e?.checked)} />
                        <label htmlFor="vatNotTaxed" className="ml-2">Es Iva no gravado</label>
                    </div>
                    <div className="mt-2">
                        <Checkbox
                            inputId="earningsWithHolding"
                            checked={isEarningsWithHolding}
                            onChange={(e: any) => setEarningsWithHolding(e.checked)} />
                        <label htmlFor="earningsWithHolding" className="ml-2">Retención de ganancias</label>
                    </div>
                    <div className="mt-2">
                        <Checkbox
                            inputId="iibbWithHolding"
                            checked={isIibbWithHolding}
                            onChange={(e: any) => setIibbWithHolding(e.checked)} />
                        <label htmlFor="iibbWithHolding" className="ml-2">Retención de IIBB</label>
                    </div>

                </div>
            </Modal>
        </>
    )
}
function CrudTaxes() {
    const { getAllTaxTypes } = useTaxService();
    const [selectedTax, setSelectedTax] = useState<any>()
    const [addMode, setAddMode] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const tableRef = useRef(null)
    const intl = useIntl()


    return (
        <div className="min-h-screen p-4 flex flex-column">
            <div className="flex justify-content-between align-items-start">
                <h2 className="text-2xl">{intl.formatMessage({ id: 'Taxes' })}</h2>
                <div className="flex flex-end">
                    <Button
                        className="buttonMain"
                        icon='pi pi-plus'
                        onClick={() => setAddMode(true)}
                    />
                    <Button
                        className="buttonMain"
                        icon='pi pi-pencil'
                        disabled={!selectedTax}
                        onClick={() => setEditMode(true)}
                    />
                </div>
            </div>


            <CustomTable
                idTable='crudTaxesTable'
                ref={tableRef}
                showGridlines
                getItems={(offSet, pageSize, params) => {
                    return getAllTaxTypes({ offSet, pageSize, params })
                }}
                resizableColumns
                hideFiltersButton
                selectedItems={selectedTax}
                onSelectionChange={(tax) => {
                    setSelectedTax(tax.value)
                }}
                selectionMode="single"
            >
                <Column field="taxname" header="Nombre" className="column" />
                <Column field="taxvalue" header="%" className="column" />
            </CustomTable>
            <TaxModal visible={addMode} setVisible={setAddMode} tableRef={tableRef}/>
            {editMode && selectedTax && <TaxModal visible={editMode} setVisible={setEditMode} tableRef={tableRef} selectedTax={selectedTax}/>}
        </div>
    )
}

export default CrudTaxes
